import _ from "lodash";
import { takeLatest, call, put } from "redux-saga/effects";
import { fetchObjectTypeInfoDocListTypes } from "../../../services/document";
import * as actions from "../documentActions";
import { openSnackbar } from "../../_shared/snack-bar/snackbarActions";

export default function* fetchLinkDocTypesWatcher() {
  yield takeLatest(actions.FETCH_LINK_DOCUMENT_TYPES, fetchLinkDocTypesWorker);
}

export function* fetchLinkDocTypesWorker(action) {
  try {
    const response = yield call(fetchObjectTypeInfoDocListTypes, action);
    yield call(success, response);
  } catch (error) {
    yield put(actions.error(error));
    yield put(openSnackbar({
      message: "Unable to load document types. Please try again.",
      showCloseIcon: true,
    }));
  }
}

export function* success(response) {
  const docTypes = _.get(response, "data.body", []);
  const excludedTypes = new Set([
    "COMMON TYPE (wm_common_type)",
    "ECM Documents (wm_ecm_documents)",
    "ECM DOCUMENTS (wm_rel_ecmdocuments)",
    "ECM DOCUMENTS (wm_ecm)",
    "Store (wm_store)",
    "STORE (wm_rel_store)",
    "System Reports (wm_system_reports)",
    "SYSTEM REPORTS (wm_rel_systemreports)",
  ]);
  const formatted = docTypes
    .filter(item => !excludedTypes.has(item.key))
    .map(item => {
      // Extract the value inside parentheses (e.g., "wm_rel_checklist" from "CHECKLISTS (wm_rel_checklist)")
      const match = item.key.match(/\(([^)]+)\)/);
      const extractedValue = match ? match[1] : item.key;
      return {
        value: extractedValue,
        label: item.key,
      };
    })
    .sort((a, b) => a.label.localeCompare(b.label));
  yield put(actions.setLinkDocumentTypes(formatted));
}